import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { InscriptionService } from 'app/service/inscription.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-paiement',
  templateUrl: './paiement.component.html',
  styleUrls: ['./paiement.component.css']
})
export class PaiementComponent implements OnInit {

  @Output() refreshData: EventEmitter<any> = new EventEmitter();
  @ViewChild('modalPaiement') modalPaiementContent: string;
  public paiementFormGroup: FormGroup;
  public types = [
    { value: 'Espèce' },
    { value: 'Chèque' }
  ];
  public choices = [
    { value: "Uniquement pour le demandeur" },
    { value: "Pour le couple complet" },
    { value: "Pour le demandeur et son accompagnant" },
    { value: "Uniquement pour l'accompagnant" },
  ]
  public typeInscription: string;
  public inscriptionDemandeur: any;
  public inscriptionCouple: any;
  public inscriptionAccompagnant: any;
  public existCouple = false;
  public existAccompagnant = false;
  public totalPrice = 0;
  public checkedChoices: any[];

  constructor(
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private inscriptionService: InscriptionService,
    private spinner: NgxSpinnerService,
  ) { }

  async ngOnInit() {
    this.paiementFormGroup = this.formBuilder.group({
      type: ['', [Validators.required]],
      numbercheque: ['', []],
      priceTotal: ['', [Validators.required]],
      observations: ['', []],
    });
  } // fin ngOnInit

  async open(data) {
    const inscriptions: any = await this.inscriptionService.getInscriptionsByNumero(data).toPromise();
    this.checkedChoices = [];
    inscriptions.forEach(async element => {
      // on vérifie s'il existe un paiement déjà associé à l'inscription
      const dataSend = {
        numero: element.numero
      };
      const paiement: any = await this.inscriptionService.getPaiementByNumero(dataSend).toPromise();
      let addInscriptionForPaiement = false;
      if (paiement.length === 0) {
        addInscriptionForPaiement = true;
      } else {
        if (paiement[0].inscriptions[0].numero !== element.numero) {
          addInscriptionForPaiement = true;
        }
      }
      if (addInscriptionForPaiement === true) {
        const checkedChoice = {
          "id": element._id,
          "numero": element.numero,
          "checked": false,
          "value": element.lastName + ' ' + element.firstName + ' - ' + element.price + ' - ' + element.type,
          "price": element.price
        };
        this.checkedChoices.push(checkedChoice);
      }
    });
    this.modalService
      .open(this.modalPaiementContent, { ariaLabelledBy: "modal-basic-title", size: 'lg', scrollable: true })
      /*.shown.subscribe(() => {
      })*/
  } // fin open

  closeModal() {
    this.paiementFormGroup.reset();
    this.modalService.dismissAll();
    this.totalPrice = 0;
    this.checkedChoices = [];
  } // fin closeModal

  changeType(event) {
    if (event.value === 'Espèce') {
      this.paiementFormGroup.controls["numbercheque"].clearValidators();
      this.paiementFormGroup.controls["numbercheque"].updateValueAndValidity();
    } else {
      this.paiementFormGroup.controls["numbercheque"].setValidators([Validators.required]);
      this.paiementFormGroup.controls["numbercheque"].updateValueAndValidity();
    }
  } // fin typeChoice

  changeChoice(event,item) {
    const priceChange = item.price.substring(0, item.price.length - 1);
    if (event.checked) {
      this.totalPrice = this.totalPrice + parseInt(priceChange);
      this.paiementFormGroup.controls["priceTotal"].setValue(this.totalPrice);
    } else {
      this.totalPrice = this.totalPrice - parseInt(priceChange);
      this.paiementFormGroup.controls["priceTotal"].setValue(this.totalPrice);
    }
  }

  async addPaiement(values) {
    this.spinner.show();
    const addInscription = this.checkedChoices.filter(x => x.checked === true)
    const dataSend = {
      "type": values.type,
      "priceTotal": values.priceTotal,
      "numbercheque": values.numbercheque,
      "inscriptions": addInscription,
      "observations": values.observations
    };
    this.inscriptionService.addPaiement(dataSend).subscribe((response: any) => {
      if (response.Paiement === 'Paiement in added successfully') {
        this.refreshData.next();
        this.toastr.success('Paiement effectué avec succès');
        this.spinner.hide();
        this.closeModal();
      } else {
        this.toastr.warning('Le serveur a rencontré un problème');
        this.spinner.hide();
      }
    });
  } // fin addPaiement

}


